module.exports = require("@mui/icons-material/ChevronRight");